import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_exgm2ufkzq: FaireBrandEntity = {
  token: "b_exgm2ufkzq",
  type: "brand",
  name: "Gray Haus",
  avatarUrl:
    "https://cdn.faire.com/fastly/91b63764ba9f348c49a74d6284b50f45a60f6adf322dbe89e856cf87acd7ccc6.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/61d700170c473b055a63e821c713041dfa370fb962054185a2c8e4fcc9ffdbb1.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/91b63764ba9f348c49a74d6284b50f45a60f6adf322dbe89e856cf87acd7ccc6.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/61d700170c473b055a63e821c713041dfa370fb962054185a2c8e4fcc9ffdbb1.jpeg",
  location: "Calgary, AB, CAN",
  minimumOrderDollars: 0,
  rating: 5,
  reviewCount: 11,
  isInsider: false,
  description:
    "Everything at Gray Haus is designed by us with guidance from our bag addiction and deeply rooted need for practicality. We are on a mission to create a brand that is here to stay with thoughtful styles to meet you wherever you are in life and take you where you're headed.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:49.444Z",
    importedBy: "entity-db-cli",
  },
};
